export enum CampaignBlastEventsEnum {
	CampaignStatusChanged = 'campaign.status.changed'
}